export default __webpack_public_path__ + "img/16.0af8b5.png";